import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use(LanguageDetector)
// pass the i18n instance to react-i18next.
.use(initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    debug: false,
    lng: 'ru', // default language - перекрывает записанное детектором языка значение
    fallbackLng: 'ru', // language to use if translations in user language are not available
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        ru: {
            translation: {
                common: {
                    about: 'О программе',
                    error: 'Ошибка',
                    loading: 'Загрузка...',
                    nouser: 'Участник не определен',
                    noevent: 'Мероприятие не определено',
                    noslots: 'Слоты не определены',
                    norequests: 'Запросы не определены',
                    noattendees: 'Участники не определены',
                    nocategories: 'Категории не определены',
                    nomeetings: 'Встреч нет',
                    privacy: 'Конфиденциальность',
                    translating: 'Переводим...',
                    translate_from_en: 'Перевести с английского',
                    translate_from_ru: 'Перевести с русского',
                },
                about: {
                    title: 'Retail Connect',
                    about: 'Интерфейс пользователя<br/>Разработан <a href="mailto:alex@molner.ru" target="_blank">Александром Федоровым</a> по заказу <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>',
                },
                login: {
                    title: 'Добро пожаловать в систему Retail Connect',
                    subtitle: 'Войдите в систему, чтобы быстро и удобно назначить встречи',
                    email: {
                        label: 'Электронная почта',
                        placeholder: 'Введите электронную почту',
                    },
                    password: {
                        label: 'Пароль',
                        placeholder: 'Введите пароль',
                    },
                    submit: 'Подключиться',
                    forgot: 'Забыли пароль? Свяжитесь с организатором',
                },
                home: {
                    title: 'Добро пожаловать',
                },
                profile: {
                    title: {
                        profile: 'Личный кабинет',
                        view: 'Мой профиль',
                        edit: 'Редактирование профиля',
                    },
                    slot: {
                        lock: 'Закрыть слот',
                        unlock: 'Открыть слот',
                        free: 'Свободен',
                        disabled: 'Закрыт',
                    },
                    edit: {
                        submit: 'Сохранить изменения',
                        cancel: 'Вернуться без сохранения',
                        email: 'Электронная почта',
                        country: 'Страна',
                        geography: 'География',
                        languages: 'Языки',
                        company_ru: 'Компания по-русски',
                        company_en: 'Компания по-английски',
                        position_ru: 'Должность по-русски',
                        position_en: 'Должность по-английски',
                        city_ru: 'Город по-русски',
                        city_en: 'Город по-английски',
                        description_ru: 'Описание по-русски',
                        description_en: 'Описание по-английски',
                        description_hint: 'до 500 знаков',
                        direct_import_legend: 'Прямой импорт',
                        direct_import_label: 'Предоставляете ли прямой экспорт?',
                        discard_confirm: 'В форме есть несохраненные данные. Хотите отменить изменения?',
                    },
                    editprofile: 'Редактировать профиль',
                    requests: 'Запросы на встречи',
                    schedule: 'Моё расписание',
                    lock: 'Кликните на замок, если не хотите принимать заявки на конкретный слот.',
                    view: 'Мой профиль',
                    print: 'Печать',
                    export: 'Добавить в свой календарь',
                    logout: {
                        title: 'Выход из кабинета',
                        confirm: 'Вы действительно хотите выйти из личного кабинета?',
                        submit: 'Выйти',
                    },
                    popup: {
                        title: 'Уважаемый участник!',
                        bayer: 'Пожалуйста, заполните свой профиль и укажите требования к поставщикам. По статистике заполненный профиль позволяет быстрее и эффективнее назначать встречи. Желаем удачи!',
                        seller: 'Пожалуйста, заполните свой профиль и укажите производственные мощности. По статистике заполненный профиль позволяет быстрее и эффективнее назначать встречи. Желаем удачи!',
                        profile: 'Пожалуйста, заполните свой профиль. По статистике заполненный профиль позволяет быстрее и эффективнее назначать встречи. Желаем удачи!',
                        bayer_categories: 'Пожалуйста, укажите требования к поставщикам. Это позволит быстрее и эффективнее назначать встречи. Желаем удачи!',
                        seller_categories: 'Пожалуйста, укажите производственные мощности. Это позволит быстрее и эффективнее назначать встречи. Желаем удачи!',
                        submit: 'Заполнить профиль',
                        submit_bayer: 'Добавить требования',
                        submit_seller: 'Добавить производственные мощности',
                    },
                },
                attendee: {
                    company: 'Компания:',
                    position: 'Должность:',
                    country: 'Страна:',
                    city: 'Город:',
                    geography: 'География:',
                    languages: 'Языки:',
                    categories: 'Категории:',
                    direct_import: 'Прямой импорт:',
                    direct_import_true: 'Есть прямой импорт',
                    direct_import_false: 'Нет прямого импорта',
                    seller: {
                        products_type: 'Тип производства',
                    },
                    bayer: {
                        products_type: 'Вид закупок',
                    },
                    products_type_stm: 'СТМ',
                    products_type_brand: 'Бренд',
                    products_type_dist: 'Дистрибуция',
                    from1: 'У вас есть ',
                    from2: 'запрос от этого участника',
                    to1: 'Вы отправили ',
                    to2: 'запрос этому участнику',
                    waiting: '. Ожидаем от него подтверждения времени встречи.',
                    needaction: '. Он ожидает от вас подтверждения времени встречи.',
                    approved1: 'У вас согласована ',
                    approved2: 'встреча с этим участником',
                    norequest: 'Если вы хотите отправить запрос о встрече с данным участником, кликните на свободный слот в расписании ниже.',
                    reason: 'Посмотреть причину.',
                    rejected: {
                        by_admin: 'Запрос от этого участника был отклонен администратором. ',
                        by_admin_my: 'Ваш запрос к этому участнику был отклонен администратором. ',
                        by_participant: 'Ранее участник отклонил ваш запрос о встрече, но вы можете попробовать снова отправить. ',
                        by_participant_own: 'Участник отозвал свой запрос о встрече с вами. ',
                        by_me: 'Ранее вы отклонили запрос от этого участника. ',
                        by_me_my: 'Вы отозвали свой запрос о встрече с этим участником. ',
                    },
                    cancelled: {
                        by_admin: 'Запрошенная участником встреча с вами была отменена администратором. ',
                        by_admin_my: 'Запрошенная вами встреча с участником была отменена администратором. ',
                        by_participant: 'Участник отменил запрошенную вами встречу. ',
                        by_participant_own: 'Участник отменил запрошенную им встречу. ',
                        by_me: 'Вы отменили запрошенную участником встречу с вами. ',
                        by_me_my: 'Вы отменили запрошенную вами встречу с участником. ',
                    },
                },
                reasons: {
                    title_reject: 'Причина отказа от встречи',
                    title_cancel: 'Причина отмены встречи',
                    hint_reject: 'Укажите здесь другую причину отказа от встречи',
                    hint_cancel: 'Укажите здесь другую причину отмены встречи',
                    submit_reject: 'Отказать во встрече',
                    submit_cancel: 'Отменить встречу',
                    cancel: 'Вернуться к запросу',
                },
                request: {
                    title: {
                        post: 'Отправка запроса',
                        request: 'Запрос на встречу',
                        meeting: 'Встреча',
                        timeover: 'Уважаемый участник!',
                        notapproved: 'Ваш профиль на модерации',
                    },
                    message_ru: 'Сопроводительный текст по-русски',
                    message_en: 'Сопроводительный текст по-английски',
                    submit: 'Отправить запрос',
                    slot: {
                        free: 'Свободен',
                        current: 'Текущий слот',
                        busy: 'Занят у меня',
                        disabled: 'Занят у участника',
                    },
                    action: {
                        chslot1: 'Предложить другое время',
                        chslot2: 'Перенести время встречи',
                        approve: 'Подтвердить встречу',
                        cancel: 'Отменить встречу',
                        cancel_confirm: 'Действительно отменить уже согласованную встречу?',
                        reject1: 'Отозвать запрос',
                        reject2: 'Отклонить запрос',
                        chslot_cancel: 'Вернуться к запросу',
                        chslot_confirm: 'Действительно изменить время встречи? Это потребует повторного согласования.',
                        notapproved: 'Для активации профиля, пожалуйста, обратитесь к организатору',
                    },
                    noslot: 'Слот запроса не найден',
                    need_trans: 'Для встречи будет предоставлен переводчик',
                    approved: 'Встреча согласована',
                    waiting: 'Ожидаем подтверждения времени встречи от собеседника',
                    needaction: 'Собеседник ожидает от вас подтверждения времени встречи',
                    moderation: 'Текст запроса находится на модерации',
                    nomessage: 'Сопроводительный текст не указан',
                    proposal: 'Файл предложения',
                    proposal_hint: 'Файл коммерческого предложения должен быть в формате PowerPoint, Excel или Word. Его размер не должен превышать 5Мб.',
                    proposal_select: 'Выбрать файл',
                    sucess_post: 'Запрос успешно отправлен',
                    success_status: 'Статус запроса успешно изменен',
                    timeover: 'Время для назначения встреч завершилось, календарь находится на модерации.<br/><br/>С наилучшими пожеланиями,<br/>ЭкспоВижнРус',
                    notapproved: 'Вы сможете назначать встречи сразу после её завершения.<br/><br/>С наилучшими пожеланиями,<br/>ЭкспоВижнРус',
                },
                category: {
                    hint_category: 'Выберите из списка',
                    hint_quantity_ru: 'шт, кг, л, и т.д.',
                    hint_quantity_en: 'units, kg, liters, etc.',
                    hint_comments: 'до 100 знаков',
                    price_segment: 'Ценовой сегмент',
                    price_segment_economy: 'Эконом',
                    price_segment_medium: 'Средний',
                    price_segment_premium: 'Премиальный',
                    submit: 'Сохранить изменения',
                    discard_confirm: 'В форме есть несохраненные данные. Хотите отменить изменения?',
                    bayer: {
                        title: 'Требования к поставщикам',
                        submit: 'Добавить требование',
                        confirm: 'Действительно удалить требование? Это действие необратимо.',
                        quantity_ru: 'Требования по-русски',
                        quantity_en: 'Требования по-английски',
                        comments_ru: 'Комментарий по-русски',
                        comments_en: 'Комментарий по-английски',
                        quantity: 'Объем закупок',
                        category: 'Категория продукта',
                        nocategories: 'Требования не определены',    
                    },
                    seller: {
                        title: 'Производственные мощности',
                        submit: 'Добавить мощности',
                        confirm: 'Действительно удалить мощность? Это действие необратимо.',
                        quantity_ru: 'Мощность по-русски',
                        quantity_en: 'Мощность по-английски',
                        comments_ru: 'Комментарий по-русски',
                        comments_en: 'Комментарий по-английски',
                        quantity: 'Мощность',
                        category: 'Категория продукта',
                        nocategories: 'Мощности не определены',    
                    },
                },
                search: {
                    title: {
                        bayer: 'Найти поставщика',
                        seller: 'Найти ритейлера',
                    },
                    expand: 'Развернуть',
                    collapse: 'Свернуть',
                    approved: 'Встреча подтверждена',
                    negotiation: 'Согласование встречи',
                    subtitle: 'Выберите интересующих вас людей и назначьте встречи',
                    allcategories: 'Все категории',
                    attendee_count_zero: 'Нет участников',
                    attendee_count_one: '{{count}} участник',
                    attendee_count_few: '{{count}} участника',
                    attendee_count_many: '{{count}} участников',
                    attendee_found_zero: 'Участников в данной категории не найдено',
                    attendee_found_one: 'Найден {{count}} участник',
                    attendee_found_few: 'Найдено {{count}} участника',
                    attendee_found_many: 'Найдено {{count}} участников',
                },
            },
        },
        en: {
            translation: {
                common: {
                    about: 'About',
                    error: 'Error',
                    loading: 'Loading...',
                    nouser: 'Attendee is not defined',
                    noevent: 'Event is not defined',
                    noslots: 'Slots not defined',
                    norequests: 'Requests not defined',
                    noattendees: 'Attendees not defined',
                    nocategories: 'Categories not defined',
                    nomeetings: 'No meetings',
                    privacy: 'Privacy Policy',
                    translating: 'Translating...',
                    translate_from_en: 'Translate from English',
                    translate_from_ru: 'Translate from Russian',
                },
                about: {
                    title: 'Retail Connect',
                    about: 'User Interface<br/>Developed by <a href="mailto:alex@molner.ru" target="_blank">Alexander Fedorov</a> commissioned by <a href="https://expovr.ru/" target="_blank">ExpoVisionRus</a>',
                },
                login: {
                    title: 'Welcome to Retail Connect',
                    subtitle: 'Log in the system and start using it for your business',
                    email: {
                        label: 'Email',
                        placeholder: 'Input email',
                    },
                    password: {
                        label: 'Password',
                        placeholder: 'Input password',
                    },
                    submit: 'Log in',
                    forgot: 'Forgot your password? Contact the organiser',
                },
                home: {
                    title: 'Welcome',
                },
                profile: {
                    title: {
                        profile: 'My Profile',
                        view: 'My Info',
                        edit: 'Edit Profile',
                    },
                    slot: {
                        lock: 'Lock slot',
                        unlock: 'Unlock slot',
                        free: 'Free',
                        disabled: 'Locked',
                    },
                    edit: {
                        submit: 'Save changes',
                        cancel: 'Return without saving',
                        email: 'Email',
                        country: 'Country',
                        geography: 'Geography',
                        languages: 'Languages',
                        company_ru: 'Company in Russian',
                        company_en: 'Company in English',
                        position_ru: 'Position in Russian',
                        position_en: 'Position in English',
                        city_ru: 'City in Russian',
                        city_en: 'City in English',
                        description_ru: 'Description in Russian',
                        description_en: 'Description in English',
                        description_hint: 'max. 500 characters',
                        direct_import_legend: 'Direct Import',
                        direct_import_label: 'Direct supply services',
                        discard_confirm: 'There is unsaved data in the form. Do you want to cancel the changes?',
                    },
                    editprofile: 'Edit profile',
                    requests: 'Requests for meetings',
                    schedule: 'My schedule',
                    lock: 'Click on the lock if you don\'t want to accept requests for a specific slot.',
                    view: 'My info',
                    print: 'Print',
                    export: 'Add to my calendar',
                    logout: {
                        title: 'Logout',
                        confirm: 'Are you sure you want to log out of your personal account?',
                        submit: 'Logout',
                    },
                    popup: {
                        title: 'Dear participant!',
                        bayer: 'Please complete your profile and enter your supplier requirements. According to statistics, a completed profile allows you to make appointments faster and more efficiently. Good luck!',
                        seller: 'Please complete your profile and enter your manufacturing capacity. According to statistics, a completed profile allows you to make appointments faster and more efficiently. Good luck!',
                        profile: 'Please complete your profile. According to statistics, a completed profile allows you to make appointments faster and more efficiently. Good luck!',
                        bayer_categories: 'Please enter the requirements for contractors. This will help you make appointments faster and more efficiently. Good luck!',
                        seller_categories: 'Please enter your production capacity. This will help you make appointments faster and more efficiently. Good luck!',
                        submit: 'Fill out profile',
                        submit_bayer: 'Add requirements',
                        submit_seller: 'Add production capacity',
                    },
                },
                attendee: {
                    company: 'Company:',
                    position: 'Position:',
                    country: 'Country:',
                    city: 'City:',
                    geography: 'Geography:',
                    languages: 'Languages:',
                    categories: 'Categories:',
                    direct_import: 'Direct import:',
                    direct_import_true: 'Direct import available',
                    direct_import_false: 'No direct import',
                    seller: {
                        products_type: 'Type of production',
                    },
                    bayer: {
                        products_type: 'Procurement type',
                    },
                    products_type_stm: 'Private Label',
                    products_type_brand: 'Brand',
                    products_type_dist: 'Distribution',
                    from1: 'You have ',
                    from2: 'a request from this participant',
                    to1: 'You sent ',
                    to2: 'a request to this participant',
                    waiting: '. We expect the participant to confirm the time of the meeting.',
                    needaction: '. The participant is waiting for you to confirm the meeting time.',
                    approved1: 'You have ',
                    approved2: 'an appointment with this participant',
                    norequest: 'If you would like to request a meeting with this participant, please click on a free slot in the schedule below.',
                    reason: 'View reason.',
                    rejected: {
                        by_admin: 'A request from this member has been denied by the admin. ',
                        by_admin_my: 'Your request to this member has been denied by the administrator. ',
                        by_participant: 'A participant declined your meeting request. ',
                        by_participant_own: 'The participant has withdrawn their request to meet with you. ',
                        by_me: 'You declined a meeting request from this member. ',
                        by_me_my: 'You have withdrawn your meeting request with this member. ',
                    },
                    cancelled: {
                        by_admin: 'A meeting with you requested by a participant has been canceled by an admin. ',
                        by_admin_my: 'The meeting you requested with a participant has been canceled by the administrator. ',
                        by_participant: 'A participant canceled the meeting you requested. ',
                        by_participant_own: 'The participant canceled the meeting they requested. ',
                        by_me: 'You canceled the meeting requested by the participant. ',
                        by_me_my: 'You canceled your requested meeting with a participant. ',
                    },
                },
                reasons: {
                    title_reject: 'Reason for rejecting the meeting',
                    title_cancel: 'Reason for canceling the meeting',
                    hint_reject: 'Please provide another reason for rejecting the meeting',
                    hint_cancel: 'Please provide another reason for canceling the meeting',
                    submit_reject: 'Reject the meeting',
                    submit_cancel: 'Cancel the meeting',
                    cancel: 'Return to the request',
                },
                request: {
                    title: {
                        post: 'Sending request',
                        request: 'Meeting Request',
                        meeting: 'Meeting',
                        timeover: 'Dear participant!',
                        notapproved: 'Your profile is in moderation',
                    },
                    message_ru: 'Accompanying text in Russian',
                    message_en: 'Accompanying text in English',
                    submit: 'Submit request',
                    slot: {
                        free: 'Free',
                        current: 'Current slot',
                        busy: 'Busy with me',
                        disabled: 'Occupied by participant',
                    },
                    action: {
                        chslot1: 'Suggest another time',
                        chslot2: 'Move meeting time',
                        approve: 'Confirm meeting',
                        cancel: 'Cancel meeting',
                        cancel_confirm: 'Are you sure you want to cancel an appointment that has already been agreed?',
                        reject1: 'Revoke request',
                        reject2: 'Reject request',
                        chslot_cancel: 'Back to request',
                        chslot_confirm: 'Are you sure you want to change the meeting time? This will require renegotiation.',
                        notapproved: 'To activate your profile, please contact the organiser',
                    },
                    noslot: 'Request slot not found',
                    need_trans: 'A translator will be provided for the meeting',
                    approved: 'Meeting approved',
                    waiting: 'We are waiting for confirmation of the meeting time from the participant',
                    needaction: 'The participant is waiting for you to confirm the meeting time',
                    moderation: 'Request text is being moderated',
                    nomessage: 'No accompanying text specified',
                    proposal: 'Proposal file',
                    proposal_hint: 'The proposal file must be in PowerPoint, Excel or Word format. Its size should not exceed 5MB.',
                    proposal_select: 'Select file',
                    sucess_post: 'Request sent successfully',
                    success_status: 'Request status changed successfully',
                    timeover: 'The time for scheduling meetings is over, the calendar is in moderation.<br/><br/>Best wishes,<br/>ExpoVisionRus',
                    notapproved: 'You will be able to send meeting requests as soon as it is completed.<br/><br/>Best wishes,<br/>ExpoVisionRus',
                },
                category: {
                    hint_category: 'Select from the list below',
                    hint_quantity_ru: 'шт, кг, л, и т.д.',
                    hint_quantity_en: 'units, kg, liters, etc.',
                    hint_comments: 'max. 100 characters',
                    price_segment: 'Price segment',
                    price_segment_economy: 'Economy',
                    price_segment_medium: 'Medium',
                    price_segment_premium: 'Premium',
                    submit: 'Save changes',
                    discard_confirm: 'There is unsaved data in the form. Do you want to cancel the changes?',
                    bayer: {
                        title: 'Supply requirements',
                        submit: 'Add requirements',
                        confirm: 'Are you sure you want to delete the requirement? This action is irreversible.',
                        quantity_ru: 'Requirements in Russian',
                        quantity_en: 'Requirements in English',
                        comments_ru: 'Comments in Russian',
                        comments_en: 'Comments in English',
                        quantity: 'Procurement volumes',
                        category: 'Product category',
                        nocategories: 'Requirements not defined',    
                    },
                    seller: {
                        title: 'Available manufacturing capacities',
                        submit: 'Add capacities',
                        confirm: 'Are you sure you want to delete capacities? This action is irreversible.',
                        quantity_ru: 'Capacities in Russian',
                        quantity_en: 'Capacities in English',
                        comments_ru: 'Comment in Russian',
                        comments_en: 'Comment in English',
                        quantity: 'Capability',
                        category: 'Product category',
                        nocategories: 'Capacities not defined',
                    },
                },
                search: {
                    title: {
                        bayer: 'Search for supplier',
                        seller: 'Search for retailer',
                    },
                    expand: 'Expand',
                    collapse: 'Collapse',
                    approved: 'Meeting confirmed',
                    negotiation: 'Meeting negotiation',
                    subtitle: 'Choose attendees and start matchmaking',
                    allcategories: 'All categories',
                    attendee_count_zero: 'No attendees',
                    attendee_count_one: 'One attendee',
                    attendee_count_other: '{{count}} attendees',
                    attendee_found_zero: 'No attendees found in this category',
                    attendee_found_one: 'One attendee found',
                    attendee_found_other: 'Found {{count}} attendees',
                },
            },
        },
    },
});

export default i18n;
